module.exports = __webpack_public_path__ + "statics/img/6.494cbdb0.gif";